import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import StaffForm from "./StaffForm";
import {
  updateStaffApi,
  getStaffByIdApi
} from "../../api/staffService";
const EditStaff = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const staffId = location?.state?.staffId;
  const [staffData, setStaffData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const loadStaff = async () => {
    try {
      setPageLoading(true);
      const res = await getStaffByIdApi(staffId);
      setStaffData(res?.data || res);
    } catch (error) {
      console.log("Fetch Staff Error:", error);
    } finally {
      setPageLoading(false);
    }
  };
  useEffect(() => {
    if (!staffId) {
      console.log("Staff ID not found");
      navigate("/staff");
      return;
    }
    loadStaff();
  },[staffId, navigate]);
  const handleUpdate = async (formData) => {
    try {
      setLoading(true);
      await updateStaffApi(staffId, formData);
      navigate("/staff");
    } catch (error) {
      console.log("Update Error:", error);
    } finally {
      setLoading(false);
    }
  };
  if (pageLoading) {
    return (
      <div className="text-center mt-4">
        Loading staff details...
      </div>
    );
  }
  return (
    <div className="container mt-4">
      <StaffForm
        initialData={{
          fullName: staffData?.fullName || "",
          gender: staffData?.gender || "",
          email: staffData?.email || "",
          clinics:
            typeof staffData?.clinics === "string"
              ? staffData.clinics
              : Array.isArray(staffData?.clinics) && staffData.clinics.length > 0
                ? staffData.clinics[0]._id || staffData.clinics[0] || ""
                : "",
        }}
        onSubmit={handleUpdate}
        loading={loading}
      />
    </div>
  );
};
export default EditStaff;